var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"languages"},[_c('div',{staticClass:"trait"}),_vm._l((_vm.$lang.locales),function(locale){return _c('btn-flag',{key:locale.code,attrs:{"locale":locale},on:{"change":_vm.onChange}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }